import { styled, Card, CardContent, Typography, Box } from '@mui/material';

import { Link } from 'theSource/components/Link';

export const CardContentStyled = styled(CardContent)(({ theme }) => ({
  '&:last-child': {
    padding: theme.spacing(6),
  },
}));

export const TitleLabelStyled = styled('h2')(({ theme }) => ({
  paddingBottom: theme.spacing(4),
  textAlign: 'left',
})) as typeof Typography;

export const CardStyled = styled(Card)(({ theme }) => ({
  borderRadius: '0.5rem',
  boxShadow: '0px 1px 10px 0px #0000003D',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
})) as typeof Card;

export const LinkStyled = styled(Link)(({ theme }) => ({
  padding: theme.spacing(2),
})) as typeof Link;
